import React from 'react';
import PropTypes from 'prop-types';
import { observer, inject } from 'mobx-react';
import { withNamespaces } from 'react-i18next';

import Header from 'apps/components/header/header';
import { MainWrapper } from 'legacyComponents/styled/lib';
import { CardSection } from 'legacyComponents/layout/cardSection';
import { ProfileCard } from 'legacyComponents/cards/types/profile';

import CommunityMembersManager from 'apps/home/community/members/appManager';

@withNamespaces()
@inject('routerStore')
@observer
export default class CommunityMembers extends React.Component {
  UNSAFE_componentWillMount() {
    this.appManager = new CommunityMembersManager(null, this.props);
  }

  render() {
    const connection = this.appManager.profilesConn;
    const profiles = connection.arrayApp;
    return (
      <>
        <Header />
        <MainWrapper>
          <CardSection
            invisible={this.appManager.loading}
            title='Community Members'
            subTitle=' '
            isOwnProfile={false}
            ownerName=''
            cardApp={profiles}
            CardComponent={ProfileCard}
            noDataCardType='profile'
            gridColumns={4}
          />
        </MainWrapper>
      </>
    );
  }
}

CommunityMembers.propTypes = {
  t: PropTypes.func,
};
